<template>
    <div>
        <b-card v-if="this.Type != 'info'">
          <p><b>Recommended Actions</b></p>
          <b-card v-if="this.Type == 'HotCold'">
           <b-row><b-col><BIconExclamationSquareFill/></b-col></b-row>
           <b-row><b-col>Hot & Cold Water Temperature</b-col></b-row>
           <b-row><b-col><p class="small">Alert has been raised as the device has breached the specified Temperature in your Risk Control Measures</p></b-col></b-row>
            <b-row>
              <b-col v-if="this.Specific == 'HotMin'"><p class="small">The device Hot Water has not reached the threshold of {{ this.SocValues.HotCold.HotMin }} &deg;C outlined</p></b-col>
              <b-col v-if="this.Specific == 'HotRet'"><p class="small">The device Hot Water Return has not reached the threshold of {{ this.SocValues.HotCold.HotRet }} &deg;C outlined</p></b-col>
              <b-col v-if="this.Specific == 'ColdMax'"><p class="small">The device Cold Water has breached the threshold of {{ this.SocValues.HotCold.ColdMax }} &deg;C outlined</p></b-col>
              <b-col v-if="this.Specific == 'ColdSupply'"><p class="small">The device Cold Supply has breached the threshold of {{ this.SocValues.HotCold.ColdSupply }} &deg;C outlined</p></b-col>
            </b-row> 
           <b-row><b-col><p class="small">Please refer to your Action Plan or Scheme of Control for the particular actions that should be carried out.</p> </b-col></b-row>
          </b-card>
          <b-card v-if="this.Type == 'Flow'">
           <b-row><b-col><BIconExclamationSquareFill/></b-col></b-row>
           <b-row><b-col>Flows</b-col></b-row>
           <b-row><b-col><p class="small">Alert has been raised as the device has breached the specified Flow Frequency in your Risk Control Measures</p></b-col></b-row>
           <b-row><b-col v-if="this.Specific == 'Flow'"><p class="small">The device has breached the threshold of a flow recorded every {{ this.SocValues.Flow.FlowFreq }} hours outlined</p>  </b-col></b-row> 
           <b-row><b-col><p class="small">Please refer to your Action Plan or Scheme of Control for the particular actions that should be carried out.</p> </b-col></b-row>
          </b-card>
          <b-card v-if="this.Type == 'TMV'">
            <b-row><b-col><BIconExclamationSquareFill/></b-col></b-row>
            <b-row><b-col>TMV</b-col></b-row>
           <b-row><b-col><p class="small">Alert has been raised as the device has breached the specified Temperature in your Risk Control Measures</p></b-col></b-row>
           <b-row>
            <b-col v-if="this.Specific == 'HotMin'"><p class="small">The device TMV Hot Input has not reached the threshold of {{ this.SocValues.TMV.TMVHot }} &deg;C outlined</p> </b-col>
            <b-col v-if="this.Specific == 'ColdMax'"><p class="small">The device TMV Cold Input has breached the threshold of {{ this.SocValues.TMV.TMVCold }} &deg;C outlined</p> </b-col>
            <b-col v-if="this.Specific == 'Mix'"><p class="small">The device TMV Mixed has breached the threshold of {{ this.SocValues.TMV.TMVMix }} &deg;C outlined</p> </b-col>
          </b-row> 
           <b-row><b-col><p class="small">Please refer to your Action Plan or Scheme of Control for the particular actions that should be carried out.</p> </b-col></b-row>
          </b-card>
          <b-card v-if="this.Type == 'Tanks'">
            <b-row><b-col><BIconExclamationSquareFill/></b-col></b-row>
            <b-row><b-col>Tanks & Heaters</b-col></b-row>
           <b-row><b-col><p class="small">Alert has been raised as the device has breached the specified values in your Risk Control Measures</p></b-col></b-row>
           <b-row>
            <b-col v-if="this.Specific == 'ColdMax'"><p class="small">The device has breached the Cold Tank Maximum threshold of {{ this.SocValues.Tanks.ColdMax }} &deg;C outlined </p> </b-col>
            <b-col v-if="this.Specific == 'HotMin'"><p class="small">The device has not reached the Hot Tank Minimum threshold of {{ this.SocValues.Tanks.HotMin }} &deg;C outlined </p> </b-col>
            <b-col v-if="this.Specific == 'HotMax'"><p class="small">The device has breached the Hot Tank Maximum threshold of {{ this.SocValues.Tanks.HotMax }} &deg;C outlined </p> </b-col>
            <b-col v-if="this.Specific == 'Combi'"><p class="small">The device has not reached the Combi Boiler Minimum threshold of {{ this.SocValues.Tanks.CombiMin }} &deg;C outlined </p> </b-col>
            <b-col v-if="this.Specific == 'POUMin'"><p class="small">The device has not reached the Point of Use Minimum threshold of {{ this.SocValues.Tanks.POUMin }} &deg;C outlined </p> </b-col>
            <b-col v-if="this.Specific == 'POUMax'"><p class="small">The device has breached the Point of Use Maximum threshold of {{ this.SocValues.Tanks.POUMax }} &deg;C outlined </p> </b-col>
            <b-col v-if="this.Specific == 'CalorOut'"><p class="small">The device has breached the Calorifier Out threshold of {{ this.SocValues.Tanks.CalorOut }} &deg;C outlined </p> </b-col>
            <b-col v-if="this.Specific == 'CalorRet'"><p class="small">The device has breached the Calorifier Return threshold of {{ this.SocValues.Tanks.CalorRet }} &deg;C outlined </p> </b-col>
          </b-row> 
           <b-row><b-col><p class="small">Please refer to your Action Plan or Scheme of Control for the particular actions that should be carried out.</p> </b-col></b-row>     
          </b-card>
          <b-card v-if="this.Type == 'CoolingTower'">
            <b-row><b-col><BIconExclamationSquareFill/></b-col></b-row>
            <b-row><b-col>Cooling Towers</b-col></b-row>
           <b-row><b-col><p class="small">Alert has been raised as the device has breached the specified values in your Risk Control Measures</p></b-col></b-row>
           <b-row>
            <b-col v-if="this.Specific == 'HotMax'"><p class="small">The device has breached the Tower threshold of {{ this.SocValues.CoolingTower.TempMax }} &deg;C outlined</p>  </b-col>
            <b-col  v-if="this.Specific == 'ColdMin'"><p class="small">The device has breached the Tower threshold of {{ this.SocValues.CoolingTower.TempMin }} &deg;C outlined</p>  </b-col>
            <b-col  v-if="this.Specific == 'Flow'"><p class="small">The device has breached the threshold of a gap in flow lasting more than {{ this.SocValues.CoolingTower.FlowFreq }} hours as outlined</p>  </b-col>
          </b-row> 
           <b-row></b-row>
           <b-row><b-col><p class="small">Please refer to your Action Plan or Scheme of Control for the particular actions that should be carried out.</p> </b-col></b-row>
          </b-card>
          <b-card v-if="this.Type == 'Custom'">
            <b-row><b-col><BIconExclamationSquareFill/></b-col></b-row>
            <b-row><b-col>Custom</b-col></b-row>
           <b-row><b-col><p class="small">Alert has been raised as the device has breached the specified values in your Risk Control Measures</p></b-col></b-row>
           <b-row>
            <b-col  v-if="this.Specific == 'HotMin'"><p class="small">The device Hot Water has not reached the threshold of {{ this.SocValues.Custom.HotMin }} &deg;C outlined </p> </b-col>
            <b-col v-if="this.Specific == 'ColdMax'"><p class="small">The device Cold Water has breached the threshold of {{ this.SocValues.Custom.ColdMax }} &deg;C outlined </p> </b-col>
            <b-col v-if="this.Specific == 'Flow'"><p class="small">The device has breached the threshold of a flow recorded every {{ this.SocValues.Custom.FlowFreq }} hours outlined</p>  </b-col>
          </b-row> 
           <b-row><b-col><p class="small">Please refer to your Action Plan or Scheme of Control for the particular actions that should be carried out.</p> </b-col></b-row>
         
          </b-card>
            
        </b-card>
    </div>
</template>

<script>
import { BIconExclamationSquareFill } from 'bootstrap-vue/dist/bootstrap-vue.esm';
import axios from "axios";
    export default {
      props:['Type','Specific'],
      data() {
      return {
        selectedlocation: localStorage.getItem("CurrentLocation"),
        CurrentName: localStorage.getItem("fullname"),
        SocValues: {
          HotCold:{
            HotMin: "",
            HotRet: "",
            ColdMax: "",
            ColdSupply: ""
          },
          Flow:{
            FlowFreq: ""
          },
          TMV:{
            TMVHot:"",
            TMVCold: "",
            TMVMix: ""
          },
          Tanks:{
            ColdMax: "",
            HotMin: "",
            HotMax: "",
            CombiMin: "",
            POUMin: "",
            POUMax: "",
            CalorOut: "",
            CalorRet: ""

          },
          CoolingTower:{
            TempMax: "",
            TempMin: "",
            FlowFreq: ""
          },
          Custom:{
            HotMin:"",
            ColdMax: "",
            FlowFreq: ""
          }
        }
       
    }
    
    },
    computed: {},
    components: {
      BIconExclamationSquareFill
    },
    mounted(){
      let lookupURL =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/controlscheme";
    let lookupHeaders = this.$apikeyPost;
    let lookupRequest = {
      RequestType: "RetrieveSOC",
        DataDict: [
    {
      Location: this.selectedlocation
      
    }
                ]
    };

    axios.post(lookupURL, lookupRequest, lookupHeaders).then((response) => {
        let responseArray = response.data.Values
        this.SocValues.HotCold.HotMin = responseArray[0][8],
        this.SocValues.HotCold.HotRet = responseArray[0][9],
        this.SocValues.HotCold.ColdMax = responseArray[0][10],
        this.SocValues.HotCold.ColdSupply = responseArray[0][11],
        this.SocValues.Flow.FlowFreq = responseArray[0][12],
        this.SocValues.TMV.TMVHot = responseArray[0][13],
        this.SocValues.TMV.TMVCold = responseArray[0][14],
        this.SocValues.TMV.TMVMix = responseArray[0][15],
        this.SocValues.Tanks.ColdMax = responseArray[0][16],
        this.SocValues.Tanks.HotMin = responseArray[0][17],
        this.SocValues.Tanks.HotMax = responseArray[0][18],
        this.SocValues.Tanks.CombiMin = responseArray[0][19],
        this.SocValues.Tanks.POUMin = responseArray[0][20],
        this.SocValues.Tanks.POUMax = responseArray[0][21],
        this.SocValues.Tanks.CalorOut = responseArray[0][22],
        this.SocValues.Tanks.CalorRet = responseArray[0][23],
        this.SocValues.CoolingTower.TempMax = responseArray[0][24],
        this.SocValues.CoolingTower.TempMin = responseArray[0][25],
        this.SocValues.CoolingTower.FlowFreq = responseArray[0][26],
        this.SocValues.Custom.HotMin = responseArray[0][27],
        this.SocValues.Custom.ColdMax = responseArray[0][28],
        this.SocValues.Custom.FlowFreq = responseArray[0][29]

    });
      

       
    },
    methods:{

    },

    }
</script>

<style>

</style>